import { createContext, useContext, useState } from 'react';
import { Associate } from '../types/associates';

// datatype of associate request context declared here
interface IAssociateRequestContext {
  associate: Associate | null;
  setAssociate: React.Dispatch<React.SetStateAction<Associate | null>>;
  showDetailsModal: boolean;
  setShowDetailsModal: React.Dispatch<React.SetStateAction<boolean>>;
}

// creating the context here
const AssociateRequestContext = createContext<IAssociateRequestContext | null>(
  null
);

const AssociateRequestProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // integration of react hooks here
  const [associate, setAssociate] = useState<Associate | null>(null);
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);

  // rendering the context provider here
  return (
    <AssociateRequestContext.Provider
      value={{ associate, setAssociate, showDetailsModal, setShowDetailsModal }}
    >
      {children}
    </AssociateRequestContext.Provider>
  );
};

export default AssociateRequestProvider;

// creating custom hook to access associate request context here
export const useAssociateRequestContext = () => {
  const context = useContext(AssociateRequestContext);

  if (!context) {
    throw new Error(
      'useAssociateRequestContext must be within AssociateRequestProvider!'
    );
  }

  return context;
};
